module.exports = __webpack_public_path__ + "img/fondo-hojas-mobile.53ff8407.png";